// Based on https://stackoverflow.com/a/57977155

export const getNewFovCameraDistance = (
  initialFov: number,
  initialDistance: number,
  initialPitch: number,
  newFov: number,
) => {
  if (initialFov === newFov) {
    return initialDistance;
  }
  const initialDepthRatio = Math.tan(((initialFov / 2.0) * Math.PI) / 180.0) * 2.0;
  const currentDepthRatio = Math.tan(((newFov / 2.0) * Math.PI) / 180.0) * 2.0;

  return initialDistance * (initialDepthRatio / currentDepthRatio) * Math.cos(initialPitch);
};
